import { useState } from "react";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { markUnmarkFavoriteMatchedJobs } from "@endpoints/job.service";
import dayjs from "@lib/dayjs";
import { useSnackbar } from "notistack";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";
import { NavLink } from "react-router-dom";
import { StarIcon } from "lucide-react";
import StarFilledIcon from "@assets/svg/StarFilledIcon";

const JobCard2 = ({ data, onClick }) => {
    const { enqueueSnackbar } = useSnackbar()
    const [isMarkedFavorite, setIsMarkedFavorite] = useState(data?.isMarkFavorite)
    const [isMarking, setIsMarking] = useState(false)

    const isAspiration = data?.tag === 'Aspiration'

    const handleMarkUnmarkFavorite = async () => {
        try {
            setIsMarking(true)
            await markUnmarkFavoriteMatchedJobs({
                isMarkFavorite: !isMarkedFavorite,
                matchId: data?._id,
                tag: data?.tag
            })
            setIsMarkedFavorite((prev) => !prev)
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error' })
        } finally {
            setIsMarking(false)
        }
    }

    return (
        <NavLink
            to={"/job-matches-details"}
            state={{ item: data }}
            onClick={onClick}
            className="grid grid-cols-[0.3fr_1.15fr_1.55fr] gap-2 items-center py-6 border-b pl-2 hover:bg-gray-50"
        >
            <div className="flex gap-7 h-full">
                <button
                    onClick={(e) => {
                        e?.preventDefault()
                        e?.stopPropagation()
                        handleMarkUnmarkFavorite()
                    }}
                    className="hover:bg-gray-100 rounded-full p-1.5 mt-2"
                >
                    {
                        isMarking ?
                            <LoadingAnimation color="#2e2e2e" /> :
                            isMarkedFavorite ?
                                <StarFilledIcon className={'h-5 w-5'} />
                                :
                                <StarIcon color="#2e2e2e" size={20} strokeWidth={1} />
                    }
                </button>
                <div className="flex flex-col items-center h-full gap-4">
                    <span className="text-xs font-medium text-primary bg-gray-50 rounded-md py-1.5 px-3 border text-center w-max">
                        {isAspiration ? 'Aspirations' : 'Profile'} Match
                    </span>
                    <div className="relative">
                        <AnimatedCircleProgress
                            progress={data?.matchingPercentage}
                            suffix="%"
                            size={55}
                            textStyle="font-bold"
                        />
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-1.5 ml-10 py-2">
                <span className="text-xs font-bold text-primary mb-2">{data?.jobTitle}</span>
                <div className="flex items-center text-xs text-primary">
                    <span className="w-20">Location:</span>
                    <span>London</span>
                </div>
                <div className="flex items-center text-xs text-primary">
                    <span className="w-20">Job Type:</span>
                    <span>Full Time/Work from home</span>
                </div>
                <div className="flex items-center text-xs text-primary">
                    <span className="w-20">Salary:</span>
                    <span>Competitve</span>
                </div>
                <span className="text-xs italic text-primary mt-2">Posted By: ABC Recruitment</span>
            </div>



            <div className="flex flex-col border-y-[0.7px] border-[#e2eef8] py-5">
                <div className="flex items-center gap-5">
                    <span className="text-xs text-primary italic">
                        {dayjs(data?.latestTracker?.updatedAt).format("hh:mm a")}
                    </span>
                    <span className="text-xs text-primary italic">
                        {dayjs(data?.latestTracker?.updatedAt).format("DD MMM YYYY")}
                    </span>
                </div>
                <div className="flex items-center gap-1 h-[3.4rem] pl-4">
                    <span className="font-bold text-primary text-xs">Closed:</span>
                    <span className="text-xs font-medium text-primary">
                        Latest Activity : {data?.latestTracker?.status || 'N/A'}
                    </span>
                </div>
            </div>


        </NavLink>
    );
};

export default JobCard2